import Section from 'components/Section/Section';

export default Section;
